import React from 'react'
import { useLocation } from 'react-router-dom'
import { FilterForm } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'
import qs from 'query-string'

const Sidebar = () => {
  const location = useLocation()
  const queryString = location.search
  const query = qs.parse(queryString)

  return (
    <div className="lg:pr-12">
      <SystemProvider>
        <FilterForm query={query} id="sidebar-filter-form"/>
      </SystemProvider>
    </div>
  )
}

export { Sidebar }
